export const getFilename = (
  projectName: string | null | undefined,
  buildTypeName: string | null | undefined,
  buildNumber: string | null | undefined,
): string =>
  projectName != null && buildTypeName != null && buildNumber != null
    ? `${projectName}_${buildTypeName}_${buildNumber}`.replace(/[^a-zA-Z0-9-#.]+/g, '_')
    : ''
